var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.modeEdit)?_c('tt-editor',{attrs:{"value":_vm.data},on:{"input":_vm.changeText}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.data)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }